import React, {useEffect} from 'react';

import Link from '../components/Link';
import {useAnalytics} from '../hooks';

const AVErrorBody = () => {
  const {tracker} = useAnalytics();

  useEffect(() => {
    tracker.duetViewAvError();
  }, []);

  return (
    <>
      {'Please try '}
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="text-indigo"
      >
        refreshing the page
      </button>
      {'. If the issue persists, please follow our '}
      <Link
        href="/practice/troubleshooting"
        target="_blank"
        className="text-indigo"
      >
        Troubleshooting Guide
      </Link>
      .
    </>
  );
};

export default AVErrorBody;
